import { IFormControl } from "../../common/interfaces/inputs";
import { Regexp } from "../../common/utils/regex.helper";

export const contactUsFormControls: {
  name: IFormControl;
  email: IFormControl;
  comment: IFormControl;
  attachment: IFormControl;
} = {
  name: {
    rules: [
      {
        required: true,
        message: "Please enter your name",
      },
      {
        pattern: Regexp.nameInput,
        message: "Please enter a valid name",
      },
    ],
    name: "name",
    placeholder: "Your Name",
    maxLength: 20,
  },
  email: {
    rules: [
      {
        type: "email",
        message: "The input is not valid E-mail",
      },
      {
        required: true,
        message: "Please input your E-mail",
      },
    ],
    name: "email",
    placeholder: "Your Email",
    maxLength: 100,
  },
  comment: {
    rules: [{ required: true, message: "Please enter your comment" }],
    name: "comment",
    placeholder: "Your Message",
    maxLength: 200,
  },
  attachment: {
    name: "attachment",
  },
};
